module.exports = __webpack_public_path__ + "img/iatalogo.e60747c2.png";